<template>
  <span
    v-tooltip="effectiveTooltip"
    class="tw-text-center tw-p-2 tw-rounded-md"
    :class="dynamicClasses"
    @click="handleClick"
  >
    <span
      class="tw-text-base tw-leading-4 tw-min-w-4 tw-w-4 tw-min-h-4 tw-h-4"
      :class="`fa fa-${icon}`"
    />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  tooltip?: string
  icon: string
  disabled?: boolean
}

const props = defineProps<Props>()

const emit = defineEmits<{ click: [] }>()

const dynamicClasses = computed(() => {
  if (props.disabled) {
    return ['tw-text-sf-neutral-lighter-2']
  }
  return [
    'sf-pointer',
    'hover:tw-bg-sf-neutral-lighter-2',
    'active:tw-bg-sf-neutral-lighter-1',
    'tw-text-sf-gray-light',
  ]
})

const effectiveTooltip = computed(() => (props.disabled ? '' : props.tooltip))

function handleClick() {
  if (!props.disabled) {
    emit('click')
  }
}
</script>
